/**
 * Product gallery by alt tags — step-based image logic.
 * material: no image | metalcolor: metal image | stone: buttons only |
 * stone color: full match then stone-only | metal color: full match then metal-only
 */
(function () {
  function normalize(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function assignTag(tags, key, value) {
    if (!key || !value) return;
    if (key === 'metalcolor' || key === 'metal-color') {
      tags.metalcolor = normalize(value);
    } else if (key === 'stonecolor' || key === 'stone-color') {
      tags.stonecolor = normalize(value);
    } else if (key === 'stone') {
      tags.stone = normalize(value);
    } else if (key === 'metal' || key === 'material') {
      tags.material = normalize(value);
    }
  }

  function parseAltTags(altText) {
    var raw = (altText || '').toLowerCase();
    var tags = {};
    if (!raw) return tags;

    // Bracket format: [metalcolor:white][stonecolor:red]
    var bracketRe = /\[([^\]:]+):([^\]]+)\]/g;
    var bracketMatch;
    while ((bracketMatch = bracketRe.exec(raw)) !== null) {
      assignTag(tags, bracketMatch[1].trim().replace(/\s+/g, ''), bracketMatch[2].trim());
    }
    if (tags.metalcolor || tags.stonecolor || tags.stone || tags.material) {
      return tags;
    }

    // Legacy comma format: metalcolor:white, stonecolor:red
    raw.split(',').forEach(function (part) {
      part = part.trim();
      if (!part) return;
      var colon = part.indexOf(':');
      if (colon < 1) return;
      assignTag(tags, part.slice(0, colon).trim().replace(/\s+/g, ''), part.slice(colon + 1).trim());
    });

    return tags;
  }

  function metalColorsMatch(tagValue, selectedValue) {
    if (!tagValue || !selectedValue) return false;
    if (tagValue === selectedValue) return true;
    if (selectedValue.indexOf(tagValue) === 0 || tagValue.indexOf(selectedValue) === 0) return true;
    return false;
  }

  function optionNameToKey(name) {
    var n = normalize(name);
    if (n === 'material') return 'material';
    if (n === 'metal-color' || n === 'metalcolor') return 'metalcolor';
    if (n === 'stone' || n === 'gem' || n === 'gemstone') return 'stone';
    if (n === 'ring-size' || n === 'size') return 'size';
    return n;
  }

  function VariantMediaController(config) {
    this.config = config;
    this.media = config.media || [];
    this.productId = config.productId;
    this.sectionId = config.sectionId;
    this.stoneColorRequired = !!config.stoneColorRequired;
    this.stoneColorsByType = config.stoneColorsByType || {};
    this.colorHex = config.colorHex || {};
    this.selectedStoneColor = '';
    this.pickerEl = null;
    this.optionsEl = null;
    this.colorInput = null;
    this.currentLabel = null;
    this.errorText = null;
    this._lastStoneType = '';
    this._variantSnapshot = { material: '', metalcolor: '', stone: '' };
  }

  VariantMediaController.prototype.getSwipers = function () {
    var bigEl = document.querySelector('.slider-big-' + this.productId);
    var smallEl = document.querySelector('.slider-small-' + this.productId);
    return {
      big: bigEl && bigEl.swiper ? bigEl.swiper : null,
      small: smallEl && smallEl.swiper ? smallEl.swiper : null,
    };
  };

  VariantMediaController.prototype.slideToIndex = function (index) {
    var swipers = this.getSwipers();
    if (!swipers.big || index < 0) return false;

    if (swipers.big.params) swipers.big.params.speed = 0;
    swipers.big.slideTo(index, 0);
    if (swipers.small) {
      if (swipers.small.params) swipers.small.params.speed = 0;
      swipers.small.slideTo(index, 0);
    }
    return true;
  };

  VariantMediaController.prototype.slideToIndexWithRetry = function (index) {
    var self = this;
    if (self.slideToIndex(index)) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (self.slideToIndex(index) || attempts >= 25) clearInterval(timer);
    }, 200);
  };

  VariantMediaController.prototype.getVariantPicker = function () {
    return (
      document.getElementById('variant-radios-' + this.sectionId) ||
      document.getElementById('variant-selects-' + this.sectionId) ||
      document.querySelector('pr-option[data-section="' + this.sectionId + '"]') ||
      document.querySelector('selects-box[data-section="' + this.sectionId + '"]')
    );
  };

  VariantMediaController.prototype.getOptionValueFromBlock = function (block) {
    if (!block) return '';

    var checked = block.querySelector('input[type="radio"]:checked');
    if (checked) return normalize(checked.value);

    var selectEl = block.querySelector('select');
    if (selectEl && selectEl.value) return normalize(selectEl.value);

    var currentEl = block.querySelector('.current-option');
    if (currentEl) return normalize(currentEl.textContent);

    return '';
  };

  VariantMediaController.prototype.getOptionValueByKey = function (wantedKey) {
    var picker = this.getVariantPicker();
    if (!picker) return '';

    var blocks = picker.querySelectorAll('.variant-option-block[data-option-name]');
    for (var i = 0; i < blocks.length; i++) {
      var key = optionNameToKey(blocks[i].getAttribute('data-option-name') || '');
      if (key === wantedKey) return this.getOptionValueFromBlock(blocks[i]);
    }
    return '';
  };

  VariantMediaController.prototype.getMetalColor = function () {
    return this.getOptionValueByKey('metalcolor');
  };

  VariantMediaController.prototype.getMaterial = function () {
    return this.getOptionValueByKey('material');
  };

  VariantMediaController.prototype.getCurrentStoneType = function () {
    var stone = this.getOptionValueByKey('stone');
    if (stone.indexOf('moissanite') !== -1) return 'moissanite';
    if (stone.indexOf('cz') !== -1 || stone === 'cubic-zirconia') return 'cz';
    return stone;
  };

  VariantMediaController.prototype.captureVariantSnapshot = function () {
    return {
      material: this.getMaterial(),
      metalcolor: this.getMetalColor(),
      stone: this.getCurrentStoneType(),
    };
  };

  VariantMediaController.prototype.getSelectedStoneColor = function () {
    if (!this.stoneColorRequired) return '';
    return normalize(this.selectedStoneColor);
  };

  VariantMediaController.prototype.findIndexByTags = function (predicate) {
    for (var i = 0; i < this.media.length; i++) {
      var item = this.media[i];
      var tags = item.tags || parseAltTags(item.alt);
      if (predicate(tags)) return item.index;
    }
    return -1;
  };

  VariantMediaController.prototype.findMetalOnlyMediaIndex = function () {
    var metal = this.getMetalColor();
    if (!metal) return 0;

    var idx = this.findIndexByTags(function (tags) {
      return metalColorsMatch(tags.metalcolor, metal);
    });
    return idx >= 0 ? idx : 0;
  };

  VariantMediaController.prototype.findBothMatchMediaIndex = function () {
    var metal = this.getMetalColor();
    var stoneColor = this.getSelectedStoneColor();
    if (!metal || !stoneColor) return -1;

    return this.findIndexByTags(function (tags) {
      return metalColorsMatch(tags.metalcolor, metal) && tags.stonecolor === stoneColor;
    });
  };

  VariantMediaController.prototype.findStoneOnlyMediaIndex = function () {
    var stoneColor = this.getSelectedStoneColor();
    if (!stoneColor) return -1;

    return this.findIndexByTags(function (tags) {
      return tags.stonecolor === stoneColor;
    });
  };

  /** Full match, else first image for the option that triggered the update */
  VariantMediaController.prototype.resolveGalleryIndex = function (fallback) {
    var both = this.findBothMatchMediaIndex();
    if (both >= 0) return both;

    if (fallback === 'stone') {
      var stoneOnly = this.findStoneOnlyMediaIndex();
      if (stoneOnly >= 0) return stoneOnly;
    } else if (fallback === 'metal') {
      return this.findMetalOnlyMediaIndex();
    }

    return 0;
  };

  VariantMediaController.prototype.updateGallery = function (strategy) {
    if (strategy === 'skip') return;

    var index = 0;
    if (strategy === 'stone-pick') {
      index = this.resolveGalleryIndex('stone');
    } else if (strategy === 'metal-pick') {
      index = this.resolveGalleryIndex('metal');
    } else {
      return;
    }

    this.slideToIndexWithRetry(index);
  };

  VariantMediaController.prototype.getChangedOptionKey = function (event) {
    var target = event && event.target;
    if (!target) return '';

    var block = target.closest('.variant-option-block[data-option-name]');
    if (!block) return '';

    return optionNameToKey(block.getAttribute('data-option-name') || '');
  };

  VariantMediaController.prototype.detectChangedKey = function (event, prev, next) {
    var fromEvent = this.getChangedOptionKey(event);
    if (fromEvent) return fromEvent;

    if (prev.stone !== next.stone) return 'stone';
    if (prev.metalcolor !== next.metalcolor) return 'metalcolor';
    if (prev.material !== next.material) return 'material';
    return '';
  };

  VariantMediaController.prototype.getColorsForStone = function (stoneType) {
    var map = this.stoneColorsByType;
    if (stoneType === 'moissanite' && map.moissanite && map.moissanite.length) return map.moissanite;
    if (stoneType === 'cz' && map.cz && map.cz.length) return map.cz;
    if (map.default && map.default.length) return map.default;
    return [];
  };

  VariantMediaController.prototype.renderStoneColorButtons = function (colors) {
    if (!this.optionsEl) return;
    var self = this;
    this.optionsEl.innerHTML = '';

    colors.forEach(function (color) {
      var key = normalize(color);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'stone-color-btn stone-color-btn--' + key;
      btn.setAttribute('data-stone-color', color);
      btn.setAttribute('data-stone-key', key);
      btn.setAttribute('aria-pressed', 'false');
      btn.textContent = color.toUpperCase();
      btn.style.color = self.colorHex[key] || '#2b2b2b';
      btn.style.borderColor = 'rgba(0,0,0,0.12)';
      btn.addEventListener('click', function () {
        self.setSelectedStoneColor(color, btn);
      });
      self.optionsEl.appendChild(btn);
    });
  };

  VariantMediaController.prototype.applyStoneColorSelection = function (color, buttonEl) {
    this.selectedStoneColor = color;
    if (this.colorInput) this.colorInput.value = color;
    if (this.currentLabel) this.currentLabel.textContent = color;
    if (this.errorText) this.errorText.hidden = true;

    if (this.pickerEl) {
      this.pickerEl.querySelectorAll('.stone-color-btn').forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });
    }
    if (buttonEl) {
      buttonEl.classList.add('is-active');
      buttonEl.setAttribute('aria-pressed', 'true');
    }
  };

  VariantMediaController.prototype.setSelectedStoneColor = function (color, buttonEl) {
    this.applyStoneColorSelection(color, buttonEl);
    this.updateGallery('stone-pick');
  };

  VariantMediaController.prototype.refreshStoneColorPicker = function (preserveColor, updateImage) {
    if (!this.pickerEl) return;

    var colors = this.getColorsForStone(this.getCurrentStoneType());
    var previousKey = preserveColor ? normalize(this.selectedStoneColor) : '';

    if (!colors.length) {
      this.pickerEl.hidden = true;
      this.selectedStoneColor = '';
      if (this.colorInput) this.colorInput.value = '';
      return;
    }

    this.pickerEl.hidden = false;
    this.renderStoneColorButtons(colors);

    var matchBtn =
      previousKey &&
      this.pickerEl.querySelector('.stone-color-btn[data-stone-key="' + previousKey + '"]');
    var firstBtn = this.pickerEl.querySelector('.stone-color-btn');
    var targetBtn = matchBtn || firstBtn;

    if (targetBtn) {
      this.applyStoneColorSelection(targetBtn.getAttribute('data-stone-color'), targetBtn);
    }

    if (updateImage) {
      this.updateGallery('stone-pick');
    }
  };

  VariantMediaController.prototype.onVariantChange = function (event) {
    var next = this.captureVariantSnapshot();
    var changedKey = this.detectChangedKey(event, this._variantSnapshot, next);
    this._variantSnapshot = next;

    if (!changedKey) return;

    if (changedKey === 'material' || changedKey === 'size') {
      return;
    }

    if (changedKey === 'stone') {
      this._lastStoneType = next.stone;
      if (this.stoneColorRequired) {
        this.refreshStoneColorPicker(false, false);
      }
      return;
    }

    if (changedKey === 'metalcolor') {
      this.updateGallery('metal-pick');
    }
  };

  VariantMediaController.prototype.bindVariantChanges = function () {
    var self = this;
    self._variantSnapshot = self.captureVariantSnapshot();
    self._lastStoneType = self.getCurrentStoneType();

    function scheduleUpdate(event) {
      var delay = self.getChangedOptionKey(event) === 'metalcolor' ? 0 : 300;
      setTimeout(function () {
        self.onVariantChange(event);
      }, delay);
    }

    var picker = self.getVariantPicker();
    if (picker) {
      picker.addEventListener('change', scheduleUpdate);
    }

    var sectionRoot = document.getElementById('MainProduct-' + self.sectionId);
    if (sectionRoot) {
      sectionRoot.addEventListener(
        'click',
        function (event) {
          if (event.target.closest('#variant-radios-' + self.sectionId + ' .op-lb')) {
            scheduleUpdate(event);
          }
        },
        true
      );
    }
  };

  VariantMediaController.prototype.bindFormValidation = function () {
    var self = this;
    var form = document.getElementById(this.config.formId);
    if (!form || !this.stoneColorRequired) return;

    form.addEventListener('submit', function (event) {
      if (!self.colorInput || self.colorInput.value) return;
      event.preventDefault();
      if (self.errorText) self.errorText.hidden = false;
    });
  };

  VariantMediaController.prototype.init = function () {
    this.pickerEl = document.querySelector('[data-stone-picker="' + this.sectionId + '"]');
    if (this.pickerEl) {
      this.optionsEl = this.pickerEl.querySelector('.stone-color-option-block__options');
      this.colorInput = this.pickerEl.querySelector('[data-stone-color-input]');
      this.currentLabel = this.pickerEl.querySelector('.stone-color-current');
      this.errorText = this.pickerEl.querySelector('.stone-color-error');
    }

    this._variantSnapshot = this.captureVariantSnapshot();
    this._lastStoneType = this.getCurrentStoneType();

    this.bindVariantChanges();
    this.bindFormValidation();

    if (this.stoneColorRequired) {
      this.refreshStoneColorPicker(true, false);
    }

    var self = this;
    setTimeout(function () {
      if (self.stoneColorRequired && self.getSelectedStoneColor()) {
        self.updateGallery('stone-pick');
      } else {
        self.updateGallery('metal-pick');
      }
    }, 1200);
  };

  function prepareConfig(configEl) {
    var config = JSON.parse(configEl.textContent);
    config.stoneColorsByType = config.stoneColorsByType || {};
    config.stoneColorsByType.cz = (config.stoneColorsByType.cz || []).map(function (c) {
      return (c || '').trim();
    }).filter(Boolean);
    config.stoneColorsByType.moissanite = (config.stoneColorsByType.moissanite || []).map(function (c) {
      return (c || '').trim();
    }).filter(Boolean);
    config.media = (config.media || []).map(function (item) {
      item.tags = parseAltTags(item.alt);
      return item;
    });
    return config;
  }

  function bootVariantMediaConfigs() {
    var nodes = document.querySelectorAll('[id^="variant-media-config-"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-op-media-booted') === '1') continue;
      try {
        var config = prepareConfig(el);
        el.setAttribute('data-op-media-booted', '1');
        var controller = new VariantMediaController(config);
        controller.init();
        if (!window.OctaPearlVariantMediaControllers) {
          window.OctaPearlVariantMediaControllers = {};
        }
        window.OctaPearlVariantMediaControllers[config.sectionId] = controller;
      } catch (e) {
        /* retry on next pass */
      }
    }
  }

  window.OctaPearlVariantMedia = {
    init: function (config) {
      config.media = (config.media || []).map(function (item) {
        item.tags = parseAltTags(item.alt);
        return item;
      });
      var controller = new VariantMediaController(config);
      controller.init();
      return controller;
    },
    boot: bootVariantMediaConfigs,
    normalize: normalize,
    parseAltTags: parseAltTags,
    metalColorsMatch: metalColorsMatch,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootVariantMediaConfigs);
  } else {
    bootVariantMediaConfigs();
  }
  window.addEventListener('load', bootVariantMediaConfigs);
  var bootTimer = setInterval(function () {
    bootVariantMediaConfigs();
  }, 200);
  setTimeout(function () {
    clearInterval(bootTimer);
  }, 6000);
})();
